import { Step, StepLabel, Stepper } from '@mui/material'
import React from 'react'
import { makeStyles } from "@mui/styles";

const style = makeStyles({
    root: {
        width: "100%",
        height: "60px",
    }
})

const Steeper = (props) => {
    const classes = style()
    // PROPS
    const { steps, activeStep } = props
    // HOOKS STATE
    // FUNCTIONS
    // VIEW
    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep}>
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel>
                            {label}
                        </StepLabel>
                    </Step>
                ))

                }

            </Stepper>
        </div>
    )
}

export default Steeper